import { Dialog } from '../ui/kit';
import { ComfortSetting } from './ComfortSetting';
import { GraphicsSetting } from './GraphicsSetting';
import { IdentitySetting } from './IdentitySetting';

/**
 * Comfort, sound and graphics, from the lobby and from the game's own menu:
 * the same dialog in both. The guest identity can be changed only from the
 * lobby, so the game leaves it out.
 */
export function SettingsDialog({ close, identity = false }: { close: () => void; identity?: boolean }) {
  return (
    <Dialog size="sm" material="housing" className="settings-dialog" onClose={close} title="Settings"
      aside={<button className="btn sm ghost" onClick={close} aria-label="Close settings">Close ×</button>}>
      <ComfortSetting />
      <GraphicsSetting />
      {identity && <IdentitySetting />}
    </Dialog>
  );
}
